import { render } from "./imprintAppSummary.vue?vue&type=template&id=1c1ff92c"
import script from "./imprintAppSummary.vue?vue&type=script&lang=js"
export * from "./imprintAppSummary.vue?vue&type=script&lang=js"

import "./imprintAppSummary.vue?vue&type=style&index=0&id=1c1ff92c&lang=css"

import exportComponent from "/buddy/vue-imprint-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__